import React from 'react';
import { styled } from '@abyss/web/tools/styled';
import { Box } from '@abyss/web/ui/Box';
import { Flex } from '@abyss/web/ui/Flex';
import { Heading } from '@abyss/web/ui/Heading';
import { Text } from '@abyss/web/ui/Text';
import { useRouter } from 'next/compat/router';
import { Button } from '@pass-frontend/abyss/common/components/button/ui';
import { ContentWidthWrapper } from '@pass-frontend/abyss/common/components/content-width-wrapper/ui';
import { MEDIA_QUERY } from '@pass-frontend/abyss/utility/style-helpers';
import {
  EventType,
  getPageName,
  logAnalyticsEvent,
} from '@pass-frontend/common/analytics';
import { getRegistrationUrl } from '@pass-frontend/common/constants/paths';
import { useIntl } from '@pass-frontend/common/i18n';
const StyledWrapper = styled(Flex, {
  padding: '32px 0',
  [MEDIA_QUERY.desktop]: {
    padding: '48px 0',
  },
});
const StyledDescription = styled(Text, {
  textAlign: 'left',
  marginBottom: '$md',
});
const StyledHeading = styled(Heading, {
  '&.abyss-heading-root': {
    fontWeight: '$normal',
    fontSize: '40px',
    marginBottom: '$md',
    [MEDIA_QUERY.mobileAndTablet]: {
      marginBottom: '$md',
      fontSize: '38px',
    },
  },
});
export const StackMembership = () => {
  const { t } = useIntl();
  const router = useRouter();
  const handleButtonClick = (event: any) => {
    logAnalyticsEvent(
      EventType.PageNav,
      {
        pageName: getPageName(router?.pathname ?? ''),
      },
      event.nativeEvent,
    );
    router?.push(getRegistrationUrl(router?.locale));
  };
  return (
    <Box color="$tint6" padding="0">
      <ContentWidthWrapper
        css={{ 'abyss-flex-root': { paddingLeft: '$sm', paddingRight: '$sm' } }}
      >
        <StyledWrapper justify="space-between" css={{ gap: '$md' }}>
          <Flex css={{ maxWidth: '584px', gap: '$md', marginBottom: '$md' }}>
            <img
              src={'/images/stack-membership.jpg'}
              alt={t('stackMembership.title')}
            />
          </Flex>
          <Flex alignItems="center">
            <Flex
              direction="column"
              alignItems="flex-start"
              css={{ maxWidth: '519px', gap: '$md' }}
            >
              <StyledHeading offset={1} textAlign="left" color="$primary1">
                {t('stackMembership.title')}
              </StyledHeading>
              <StyledDescription size="$md" color="$primary1">
                {t('stackMembership.description')}
              </StyledDescription>
              <Button
                onClick={handleButtonClick}
                data-ui-element-name="Start saving today button"
              >
                {t('stackMembership.button')}
              </Button>
            </Flex>
          </Flex>
        </StyledWrapper>
      </ContentWidthWrapper>
    </Box>
  );
};
